import {Injectable} from "@angular/core";
import {AngularFireAuth} from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import {UserService} from '../users/services/user.service';
import {User} from '../users/models/user';
import { Observable }      from 'rxjs/Observable';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/of';

@Injectable()
export class AuthService {

  constructor(private af: AngularFireAuth, private userService: UserService) { }

  loginWithGoogle() {
    return this.af.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
  }

  loginWithFacebook() {
    return this.af.auth.signInWithPopup(new firebase.auth.FacebookAuthProvider());
  }

  loginWithCredentials(email: string, password: string) {
    return this.af.auth.signInWithEmailAndPassword(email, password);
  }

  registerUser(email: string, password: string) {
    return this.af.auth.createUserWithEmailAndPassword(email, password);
  }

  logout() {
    return this.af.auth.signOut();
  }

  Send(email: string) {
      return this.af.auth.sendPasswordResetEmail(email);
  }

  getUser(): Observable<User> {
    return this.af.authState.flatMap(user => user ? this.userService.getUser(user.uid) : Observable.of(null));
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/auth.service.ts